import {
  ADMIN_COMPANIES_ROUTE,
  HOME_ROUTE,
  PEOPLE_ROUTE,
  PROFILE_ROUTE,
  ADMIN_SETTINGS_MAINTENANCE_ROUTE,
  AIRLINEPROGRAMS_ROUTE,
  PEOPLE_TEAMS_ROUTE,
  PEOPLE_GUEST_ROUTE,
  PEOPLE_REMOVED_ROUTE,
  ESCALATION_FORM_ROUTE,
} from "./routes";
import { FormattedMessage, defineMessages } from "react-intl";
import toBoolean from "helpers/toBoolean";

export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN
export const AA_FOP_SCRIPT = process.env.REACT_APP_AA_FOP_SCRIPT
export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN
export const APP_PREFIX = process.env.REACT_APP_PREFIX
export const API_PROTOCOL = process.env.REACT_APP_API_PROTOCOL || window.location.protocol
export const API_HOST = process.env.REACT_APP_API_HOST || window.location.host
export const DEFAULT_LOCALE = "en_US";
export const IS_ADMIN_PERMISSION = "F_PROVIDER_ADMIN";
export const DASH_CLIENT_LOGO_URL = process.env.REACT_APP_DASH_CLIENT_LOGO_URL
export const DASH_CLIENT_MOBILE_LOGO_URL = process.env.REACT_APP_DASH_CLIENT_MOBILE_LOGO_URL
export const DELTA_SKYMILESENROLL_LINK = process.env.REACT_APP_DELTA_SKYMILESENROLL_LINK
export const DELTA_FORGOTLOGIN_LINK = process.env.REACT_APP_DELTA_FORGOTLOGIN_LINK
export const DELTA_PRIVACYPOLICY_LINK = process.env.REACT_APP_DELTA_PRIVACYPOLICY_LINK
export const VERSA_LINK_SCRIPT_SRC = process.env.REACT_APP_VERSA_LINK_SCRIPT_SRC
export const API_SAMPLES = {
  UC: process.env.REACT_APP_UC_SAMPLE,
  AA: process.env.REACT_APP_AA_SAMPLE,
  AM: process.env.REACT_APP_AM_SAMPLE,
  AS: process.env.REACT_APP_AS_SAMPLE,
  CHOICE: process.env.REACT_APP_CH_SAMPLE,
  AC: process.env.REACT_APP_AC_SAMPLE,
}
export const TRIPIT_LINKS = {
  UC: process.env.REACT_APP_UC_TRIPIT_LINK,
  AA: process.env.REACT_APP_AA_TRIPIT_LINK,
  AM: process.env.REACT_APP_AM_TRIPIT_LINK,
  AS: process.env.REACT_APP_AS_TRIPIT_LINK,
  CHOICE: process.env.REACT_APP_CH_TRIPIT_LINK,
  AC: process.env.REACT_APP_AC_TRIPIT_LINK,
}

export const TERMS_AND_CONDITIONS_LINKS = {
  UC: process.env.REACT_APP_UC_TERMS_LINK,
  AA: process.env.REACT_APP_AA_TERMS_LINK,
  AM: process.env.REACT_APP_AM_TERMS_LINK_ES,
  AS: process.env.REACT_APP_AS_TERMS_LINK,
  CHOICE: process.env.REACT_APP_CH_TERMS_LINK,
  AC: process.env.REACT_APP_AC_TERMS_LINK,
}

export const REACT_APP_POLICY_LINKS = {
  AA: process.env.REACT_APP_AA_POLICY_LINK,
  UC: process.env.REACT_APP_UC_POLICY_LINK,
  AM: process.env.REACT_APP_AM_POLICY_LINK,
  AS: process.env.REACT_APP_AS_POLICY_LINK,
  CHOICE: process.env.REACT_APP_CH_POLICY_LINK,
  AC: process.env.REACT_APP_AC_POLICY_LINK,
}

export const AA_COOKIE_BANNER_SCRIPT = process.env.REACT_APP_AA_COOKIE_SCRIPT_URL
export const AA_DCF_SCRIPT = process.env.REACT_APP_AA_DCF_SCRIPT
export const AA_QUANTUM_SCRIPT = process.env.REACT_APP_AA_QUANTUM_SCRIPT
export const MANAGE_TRIP_LINKS = {
  AA: process.env.REACT_APP_AA_MANAGE_TRIP_LINK,
  AM: process.env.REACT_APP_AM_MANAGE_TRIP_LINK,
  AS: process.env.REACT_APP_AS_MANAGE_TRIP_LINK,
  CHOICE: process.env.REACT_APP_CH_MANAGE_TRIP_LINK,
  AC: process.env.REACT_APP_AC_MANAGE_TRIP_LINK,
}
export const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT
export const RELEASE_VERSION = process.env.REACT_APP_RELEASE_VERSION
export const SENTRY_ENABLED = toBoolean(process.env.REACT_APP_SENTRY_ENABLED);
export const BOOK_TRAVEL_URLS = {
  AA: process.env.REACT_APP_AA_BOOK_TRAVEL_URL,
  UC: process.env.REACT_APP_UC_BOOK_TRAVEL_URL,
  AM: process.env.REACT_APP_AM_BOOK_TRAVEL_URL,
  AS: process.env.REACT_APP_AS_BOOK_TRAVEL_URL,
  CHOICE: process.env.REACT_APP_CH_BOOK_TRAVEL_URL,
  AC: process.env.REACT_APP_AC_BOOK_TRAVEL_URL,
}

export const HELP_URLS = {
  AA: process.env.REACT_APP_AA_HELP_URL,
  UC: process.env.REACT_APP_UC_HELP_URL,
  AM: process.env.REACT_APP_AM_HELP_URL,
  AS: process.env.REACT_APP_AS_HELP_URL,
  CHOICE: ESCALATION_FORM_ROUTE,
  AC: process.env.REACT_APP_AC_HELP_URL,
}

export const REACT_APP_BASIC_ECONOMY_LINK = {
  AA: process.env.REACT_APP_AA_BASIC_ECONOMY_LINK,
  UC: process.env.REACT_APP_UC_BASIC_ECONOMY_LINK,
  AM: process.env.REACT_APP_AM_BASIC_ECONOMY_LINK,
  CHOICE: process.env.REACT_APP_CH_BASIC_ECONOMY_LINK,
  AC: process.env.REACT_APP_AC_BASIC_ECONOMY_LINK,
}

export const REACT_APP_MANAGING_TRAVEL_POLICY_LINKS = {
  AA: process.env.REACT_APP_AA_MANAGING_TRAVEL_POLICY_LINK,
  UC: process.env.REACT_APP_UC_MANAGING_TRAVEL_POLICY_LINK,
  AM: process.env.REACT_APP_AM_MANAGING_TRAVEL_POLICY_LINK,
  AS: process.env.REACT_APP_AS_MANAGING_TRAVEL_POLICY_LINK,
  CHOICE: process.env.REACT_APP_CH_MANAGING_TRAVEL_POLICY_LINK,
  AC: process.env.REACT_APP_AC_MANAGING_TRAVEL_POLICY_LINK,
}

export const DCF_JQUERY_SCRIPT = "https://code.jquery.com/jquery-3.6.0.min.js"
export const VIEW_FLIGHT_ON_AA = "https://www.aa.com/travelInformation/flights/status/detail?search={searchDetails}&ref=search"
export const REDIRECT_AA_BANNER_LINK = "https://www.aa.com/aadvantage-program/buy-gift-transfer/en_US/home/buy"

export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN

export const REDIRECT_PATH = API_PROTOCOL + "://" + API_HOST

export const DEFAULT_REDIRECT_ASSOCIATIONS = {
  AA: HOME_ROUTE,
  UC: HOME_ROUTE,
  AS: PEOPLE_ROUTE,
  CHOICE: HOME_ROUTE,
  AM: PEOPLE_ROUTE,
  AC: PEOPLE_ROUTE,
}

export const REDIRECT_ASSOCIATIONS = {
  HOME: "../" + HOME_ROUTE,
  PEOPLE: "../" + PEOPLE_ROUTE,
  COMPANIES: "../" + ADMIN_COMPANIES_ROUTE,
  TRAVELER_SETTINGS: "../" + PROFILE_ROUTE,
  MAINTENANCEMODE_ADMIN: "../" + ADMIN_SETTINGS_MAINTENANCE_ROUTE,
  JOIN: "../" + AIRLINEPROGRAMS_ROUTE
}

export const AIRLINES = {
  AA: "AA",
  UC: "UC",
  AS: "AS",
  AM: "AM",
  CHOICE: "CHOICE",
  AC: "AC",
}

export const AATripGuideLinks = {
  EN: process.env.REACT_APP_AA_TRIP_GUIDE_EN,
  ES: process.env.REACT_APP_AA_TRIP_GUIDE_ES,
  FR: process.env.REACT_APP_AA_TRIP_GUIDE_FR,
  PT: process.env.REACT_APP_AA_TRIP_GUIDE_PT,
}

export const PAGE_TITLES = {
  "domains": "email domains", // /app/settings/email-domains
  "login": "aadvb login", // /app/login
  "integrations": "integrations", // /app/settings/integrations
  "activeCompanies": "active companies", // /app/admin/companies
  "pendingCompanies": "pending companies", // /app/admin/companies/pending
  "removedCompanies": "companies removed", // /app/admin/companies/removed
  "escalationForm": "escalation form", // /app/escalation-form
  "escalationFormConfirmation": "escalation confirm", // /app/escalation-message
  "home": "home", // /app/home
  "people": "people", // /app/people
  "removedPeople": "people removed", // /app/people/removed
  "teams": "teams", // /app/teams
  "trips": "trips", // /app/safety
  "reports": "reports", // /app/reports/bookings
  "mileage": "mileage", // /app/reports/mileage
  "receipts": "receipts", // /app/reports/receipts
  "settings": "settings", // /app/settings
  "teamDetails": "team details", // /app/teams/[teamId]
  "travelerDetails": "traveler details", // /app/people/[travelerId]
  "profile": "profile", // /app/profile
  "leaveCompany": "leave company", // /app/leave-company
  "domainVerified": "domain verified", // /app//domain-verification-success
  "domainRevoked": "domain revoked", // /app//domain-verification-failure
  "companyDetails": "company details", // /app/admin/companies/[companyEntityId]
  "notFound": "404 error", // /404
  "errorPage": "error", // 500
  "unauthorizedPage": "unauthorized", // /403
  "maintenance": "Maintenance", // /app/maintenance
  "adminMaintenance": "admin maintenance", // /app/admin/settings/maintenance
  "join": "join", // /app/join
  "unitedAirlines": "united airlines", // /app/join/united-airlines
  "americanAirlines": "american airlines", // /app/join/american-airlines
  "deltaAirlines": "delta airlines", // /app/join/delta-airlines
  "deltaAirlinesProgram": "delta airlines program", // /app/join/delta-airlines-program
  "travelerDetailsJoin": "traveler details join", // /app/people/[travelerId]/join
  "adminLoyaltyPending": "Admin loyalty pending", // /app/admin/loyalty/allotments
  "adminLoyaltyFailed": "Admin loyalty failed", // /app/admin/loyalty/allotments/failed
  "adminLoyaltyCompleted": "Admin loyalty completed", // /app/admin/loyalty/allotments/completed
  "payment": "payment", // /app/payment
  "travelCredits": "travel credits", // /app/travelcredits
  "availableCredits": "available credits", // /app/travelcredits/available
  "usedCredits": "used credits", // /app/travelcredits/used
  "expiredCredits": "expired credits", // /app/travelcredits/expired
  "adminPeople": "admin people", // /app/admin/people
  "adminRemovedPeople": "admin removed people", // /app/admin/people
  "adminTravelerDetails": "admin traveler details", // /app/admin/people/details
  "adminLoyaltyRequestsPending": "Admin loyalty requests pending", // /app/admin/loyalty/requests/pending
  "adminLoyaltyRequestsFailed": "Admin loyalty requests failed", // /app/admin/loyalty/requests/failed
  "adminLoyaltyRequestsCompleted": "Admin loyalty requests completed", // /app/admin/loyalty/requests/completed
  "summary": "summary" // /app/reports/summary
}

export const FOP_SERVICE_URL = process.env.REACT_APP_FOP_SERVICE_URL;

export const securityPolicyContent = {
  UC: `       
    default-src 'self' ${process.env.REACT_APP_API_HOST} wss://nexus-websocket-a.intercom.io https://api-iam.intercom.io;
    script-src 'self' https://js.intercomcdn.com https://widget.intercom.io https://cdnjs.cloudflare.com;
    style-src 'self' https://fonts.googleapis.com;
    img-src 'self' data: https://*.mapbox.com https://*.traverse.tech https://*.nutravel.com https://cdnjs.cloudflare.com;
    font-src 'self' data: https://fonts.gstatic.com;
    connect-src 'self' https://api.mapbox.com https://events.mapbox.com https://*.traverse.tech https://*.nutravel.com https://*.nutravel.com https://*.sentry.io;
    worker-src 'self' blob:;
    object-src 'none';
    frame-src 'self';
    media-src 'self';
    base-uri 'self';
    form-action 'self'; 
    `,
  AA: ` 
    default-src 'self' ${process.env.REACT_APP_API_HOST} https://www.aa.com https://smetrics.aa.com https://logs.mezmo.com https://api.mapbox.com https://events.mapbox.com https://services.aa.com https://qa.services.aa.com https://tags.tiqcdn.com https://qa.cdn.aa.com https://cdn.aa.com https://13196098.fls.doubleclick.net https://td.doubleclick.net https://o4506388900806656.ingest.sentry.io https://aa-sync.quantummetric.com https://rl.quantummetric.com https://ingest.quantummetric.com/aa https://dpm.demdex.net data; 
    script-src 'self' ${process.env.REACT_APP_AA_COOKIE_SCRIPT_URL} ${process.env.REACT_APP_AA_QUANTUM_SCRIPT} ${process.env.REACT_APP_VERSA_LINK_SCRIPT_SRC} ${DCF_JQUERY_SCRIPT} https://cdn.quantummetric.com https://www.googletagmanager.com https://www.everestjs.net  https://tags.tiqcdn.com https://qa.cdn.aa.com https://cdn.aa.com https://pixel.sojern.com https://cdnjs.cloudflare.com; 
    style-src 'self' https://www.aa.com ; 
    img-src 'self' data: https://ad.doubleclick.net https://*.mapbox.com https://*.aa.com https://*.nutravel.com https://cdnjs.cloudflare.com;
    font-src 'self' https://www.aa.com data:;
    connect-src 'self' https://api.mapbox.com https://events.mapbox.com https://*.aa.com https://*.nutravel.com https://*.nutravel.com https://*.sentry.io;
    worker-src 'self' blob:;
    object-src 'none';
    frame-src 'self';
    media-src 'self';
    base-uri 'self';
    form-action 'self';
    `,
  AS: `       
    default-src 'self' ${process.env.REACT_APP_API_HOST} https://api.mapbox.com https://events.mapbox.com;
    script-src 'self' https://cdnjs.cloudflare.com;
    style-src 'self' https://fonts.googleapis.com;
    img-src 'self' https://cdnjs.cloudflare.com data: https://*.mapbox.com https://*.alaskaair.com https://*.nutravel.com https://cdnjs.cloudflare.com;
    font-src 'self' data: https://fonts.gstatic.com;
    connect-src 'self' https://api.mapbox.com https://events.mapbox.com https://*.alaskaair.com https://*.nutravel.com https://*.nutravel.com https://*.sentry.io;
    worker-src 'self' blob:;
    object-src 'none';
    frame-src 'self' ${FOP_SERVICE_URL};
    media-src 'self';
    base-uri 'self';
    form-action 'self';
    `,
  //todo: testing needed when AM integrated
  AM: ` 
    default-src 'self' ${process.env.REACT_APP_API_HOST}; 
    script-src 'self' 'unsafe-eval'; 
    style-src 'self' 'unsafe-inline'; 
    img-src 'self' data:; 
    font-src 'self' data:;
    worker-src 'self' blob:; 
  `,
  CHOICE: ` 
    default-src 'self' ${process.env.REACT_APP_API_HOST} https://api.mapbox.com https://events.mapbox.com;
    script-src 'self' https://api.mapbox.com https://cdnjs.cloudflare.com;
    style-src 'self' https://fonts.googleapis.com;
    img-src 'self' data: https://*.mapbox.com https://*.choicehotels.com https://*.nutravel.com https://cdnjs.cloudflare.com;
    font-src 'self' data: https://fonts.gstatic.com;
    connect-src 'self' https://api.mapbox.com https://events.mapbox.com https://*.choicehotels.com https://*.nutravel.com https://*.nutravel.com https://*.sentry.io;
    worker-src 'self' blob:;
    object-src 'none';
    frame-src 'self' ${FOP_SERVICE_URL};
    media-src 'self';
    base-uri 'self';
    form-action 'self';
  `,
  //todo: testing needed when AC integrated
  AC: ` 
    default-src 'self' ${process.env.REACT_APP_API_HOST}; 
    script-src 'self' 'unsafe-eval'; 
    style-src 'self' 'unsafe-inline'; 
    img-src 'self' data:; 
    font-src 'self' data:;
    worker-src 'self' blob:; 
    frame-src 'self' ${process.env.REACT_APP_AC_TECHNICAL_SUPPORT_URL} ${process.env.REACT_APP_AC_BUSINESS_SUPPORT_URL};
  `,
};

export const roles = {
  "secondaryAdminRole": "9",
  "travelManegerRole" : "8",
  "travelerRole" : "7"
}

export const maintenanceStatus = {
  "on" : "ON",
  "off" : "OFF"
}

export const additionalTimeZones = {
  'Europe/Bucharest': 'Bucharest',
  "America/Puerto_Rico": "Puerto_Rico",
}

export const titleTranslations = {
  UC: {
    title: {
      id: "title.UC"
    },
    admin: {
      id: "title.UCadmin"
    }
  },
  AA: {
    title: {
      id: "title.AA"
    },
    admin: {
      id: "title.AAadmin"
    }
  },
  AS: {
    title: {
      id: "title.AS"
    },
    admin: {
      id: "title.ASadmin"
    }
  },
  CHOICE: {
    title: {
      id: "title.CHOICE"
    },
    admin: {
      id: "title.CHOICEadmin"
    }
  },
  AM: {
    title: {
      id: "title.AM"
    },
    admin: {
      id: "title.AMadmin"
    }
  },
  AC: {
    title: {
      id: "title.AC"
    },
    admin: {
      id: "title.ACadmin"
    }
  }
}

export const exipiryCardsDuration = {
  AA: "182",
  UC: "182",
  AS: "182",
  AM: "182",
  CHOICE: "182",
  AC: "182",
} //6 months ~ 182 days

export const assignTypes = {
  card: "card",
  policy: "policy"
}

export const AA_LEP_HELP_URL = process.env.REACT_APP_AA_LEP_HELP_URL ?? HELP_URLS.AA;

export const aaPolicyCabinOptions = [
  {
    value: "1",
    label: <FormattedMessage id="aaPolicyCabinOptions.option1" />,
  },
  {
    value: "2",
    label: <FormattedMessage id="aaPolicyCabinOptions.option2" />,
  },
  {
    value: "3",
    label: <FormattedMessage id="aaPolicyCabinOptions.option3" />,
  },
];

export const LEPv2Changes = false;

export const pendingInvitationsExpireTime = {
  AA: 21,
  UC: 21,
  AS: 30,
  AM: 30,
  CHOICE: 21,
  AC: 45,
}

//each number represents the ID of the failure reason that comes from BE
export const loyaltyFailureReasons = defineMessages({
  1: {
    id: "loyaltyFailureReason.allotmentFailed",
  },
  2: {
    id: "loyaltyFailureReason.insufficientBalance",
  },
  3: {
    id: "loyaltyFailureReason.redemptionFailed",
  },
  4: {
    id: "loyaltyFailureReason.failedToRedeem",
  },
  5: {
    id: "loyaltyFailureReason.internalError",
  },
  6: {
    id: "loyaltyFailureReason.invalidRequest",
  },
  7: {
    id: "loyaltyFailureReason.unableToRedeem",
  },
  8: {
    id: "loyaltyFailureReason.allotmentAlreadyExists",
  },
  9: {
    id: "loyaltyFailureReason.currentStatusHigher",
  }
})

export const API_DOWNLOAD_ALLOTMENTS_SAMPLE = process.env.REACT_APP_AA_DOWNLOAD_ALLOTMENTS_SAMPLE;

export const AA_HOME_LINK = "https://www.aa.com"
export const AS_HOME_LINK = "https://www.alaskaair.com"
export const DELTA_HOME_LINK = "https://www.delta.com"
export const UNITED_HOME_LINK = "https://www.united.com"

export const DEDUPE_HA_ERROR_CODE = '2001'
export const AA_RETRO_SAMPLE = process.env.REACT_APP_AA_RETRO_SAMPLE

export const CHOICE_TERMS_OF_USE_LINK = process.env.REACT_APP_CH_TERMS_OF_USE_LINK
export const ARC_POLICY_LINK = process.env.REACT_APP_ARC_POLICY_LINK
export const AC_TECHNICAL_SUPPORT_URL = process.env.REACT_APP_AC_TECHNICAL_SUPPORT_URL
export const AC_BUSINESS_SUPPORT_URL = process.env.REACT_APP_AC_BUSINESS_SUPPORT_URL
export const AC_BUSINESS_SUPPORT_URL_FR = process.env.REACT_APP_AC_BUSINESS_SUPPORT_URL_FR

export const AC_TERMS_PRIVACY_POLICY_LINK = "https://www.aircanada.com/ca/en/aco/home/legal/privacy-policy.html#/";
export const AC_TERMS_BUSINESS_TRAVEL_LINK = "https://www.aircanada.com/ca/en/aco/home/book/business-travel.html";
export const AC_TERMS_SUPPORT_FORM_LINK = "https://smb.aircanada.com/smerequestsupportform?redirect=false";
export const AC_TERMS_CARRIAGE_LINK = "https://www.aircanada.com/ca/en/aco/home/legal/conditions-carriage-tariffs.html#/";
export const AC_TERMS_AEROPLAN_LINK = "https://www.aircanada.com/ca/en/aco/home/aeroplan/legal/terms-and-conditions.html#/";

export const configPeopleHeader =  {
  people: {
    titleId: "people.title",
    subtitleId: "people.subtitle",
    colSize: 12,
    btnClassName: "",
    actions: [
      "overlayButton",
      "bulkUpload",
      "pendingInvites",
      "inviteUser",
    ]
  },
  teams: {
    titleId: "teams.title",
    subtitleId: "teams.subtitle",
    colSize: 12,
    btnClassName: "teamsActions",
    actions: [
      "overlayButton",
      "bulkUpload",
      "createGroup",
    ]
  },
  guest: {
    titleId: "people.title",
    subtitleId: "people.subtitle",
    colSize: 12,
    btnClassName: "",
    actions: [
      "uploadProfiles",
      "createProfile",
    ]
  },
  removed: {
    titleId: "people.title",
    subtitleId: "people.subtitle",
    colSize: 12,
    btnClassName: "",
    actions: [
      "overlayButton",
      "bulkUpload",
      "pendingInvites",
      "inviteUser",
    ]
  }
}

export const getNorthAmericaCountries = (intl) => [
  { value: "US", label: intl.formatMessage({ id: "countries.unitedStates"}) },
  { value: "CA", label: intl.formatMessage({ id: "countries.canada"}) },
]
export const maxPromoCodesAllowed = 20

export const configPeopleHeaderTabs = {
  [PEOPLE_ROUTE]: "people",
  [PEOPLE_TEAMS_ROUTE]: "teams",
  [PEOPLE_GUEST_ROUTE]: "guest",
  [PEOPLE_REMOVED_ROUTE]: "removed",
};

export const csvSpinners = {
  guestProfilesCSV: "uploadGuestProfilesFileSpinner"
}

export const GUEST_PROFILES_SAMPLE = process.env.REACT_APP_GUEST_PROFILES_SAMPLE;

export const AADVANTAGE_PROGRAM_DATA = {
  explorePackageUrl: "https://aa.com/aadvantage-program/buy-gift-transfer/en_US/home/aadvantage-pass/details/1",
  loginUrl: "https://www.aa.com/aadvantage-program/profile/account-summary",
  faqUrl: "https://www.aa.com/web/i18n/aadvantage-program/answers-support/buy-gift-transfer-faq.html",
  tandcUrl: "https://aa.com/aadvantage-program/buy-gift-transfer/aadvantage-pass/en_US/termsAndConditions",
  contactNumber: "877-229-8278",
  goldPrice: "$5,000"
}

export const TAX_ID_REGEXES = {
  US: { regex: /^\d{2}-\d{7}$/, expectedFormat: "12-3456789" },
  DE: { regex: /^DE\d{9}$/, expectedFormat: "DE123456789" },
  AU: { regex: /^\d{11}$/, expectedFormat: "12345678912" },
  BR: { regex: /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/, expectedFormat: "12.345.678/9012-34" },
  CA: { regex: /^\d{9}$/, expectedFormat: "123456789" },
  CL: { regex: /^\d{2}\.\d{3}\.\d{3}-[A-Z]$/, expectedFormat: "12.345.678-K" },
  CN: { regex: /^\d{18}$/, expectedFormat: "123456789012345678" },
  EC: { regex: /^\d{13}$/, expectedFormat: "1234567890123" },
  EG: { regex: /^\d{9}$/, expectedFormat: "123456789" },
  HK: { regex: /^\d{8}$/, expectedFormat: "12345678" },
  IN: { regex: /^\d{2}[A-Z]{5}\d{4}[A-Z]\d[A-Z]\d$/, expectedFormat: "12ABCDE3456F7Z8" },
  JP: { regex: /^\d{13}$/, expectedFormat: "1234567890123" },
  LT: { regex: /^LT\d{9}$/, expectedFormat: "LT123456789" },
  LU: { regex: /^LU\d{8}$/, expectedFormat: "LU12345678" },
  LV: { regex: /^LV\d{11}$/, expectedFormat: "LV12345678901" },
  MT: { regex: /^MT\d{8}$/, expectedFormat: "MT12345678" },
  NL: { regex: /^NL\d{9}B\d{2}$/, expectedFormat: "NL123456789B01" },
  PL: { regex: /^PL\d{10}$/, expectedFormat: "PL1234567890" },
  PT: { regex: /^PT\d{9}$/, expectedFormat: "PT123456789" },
  RO: { regex: /^RO\d{2,10}$/, expectedFormat: "RO1234567890" },
  SE: { regex: /^SE\d{12}$/, expectedFormat: "SE123456789001" },
  SI: { regex: /^SI\d{8}$/, expectedFormat: "SI12345678" },
  SK: { regex: /^SK\d{10}$/, expectedFormat: "SK1234567890" },
  TR: { regex: /^TR\d{10}$/, expectedFormat: "TR1234567890" },
  TW: { regex: /^TW\d{8}$/, expectedFormat: "TW12345678" },
  UA: { regex: /^UA\d{10}$/, expectedFormat: "UA1234567890" },
  GB: { regex: /^GB\d{9}$/, expectedFormat: "GB123456789" },
  VN: { regex: /^VN\d{10}[A-Z]\d$/, expectedFormat: "VN1234567890A1" },
  AD: { regex: /^A-\d{6}-[A-Z]$/, expectedFormat: "A-123456-Z" },
  AR: { regex: /^\d{2}-\d{8}-\d{2}$/, expectedFormat: "12-34567890-12" },
  BE: { regex: /^BE\d{10}$/, expectedFormat: "BE0123456789" },
  BO: { regex: /^\d{9}$/, expectedFormat: "123456789" },
  BG: { regex: /^BG\d{9}$/, expectedFormat: "BG123456789" },
  CO: { regex: /^\d{3}\.\d{3}\.\d{3}-\d$/, expectedFormat: "123.456.789-0" },
  CR: { regex: /^\d-\d{3}-\d{6}$/, expectedFormat: "1-234-567890" },
  HR: { regex: /^HR\d{11}$/, expectedFormat: "HR12345678912" },
  CY: { regex: /^CY\d{8}[A-Z]$/, expectedFormat: "CY12345678Z" },
  CZ: { regex: /^CZ\d{10}$/, expectedFormat: "CZ1234567890" },
  DK: { regex: /^DK\d{8}$/, expectedFormat: "DK12345678" },
  DO: { regex: /^\d{3}-\d{7}-\d$/, expectedFormat: "123-4567890-1" },
  SV: { regex: /^\d{4}-\d{6}-\d{3}-\d$/, expectedFormat: "1234-567890-123-4" },
  EE: { regex: /^EE\d{9}$/, expectedFormat: "EE123456789" },
  FI: { regex: /^FI\d{8}$/, expectedFormat: "FI12345678" },
  FR: { regex: /^FR[A-Z0-9]{2}\d{9}$/, expectedFormat: "FRAB123456789" },
  GE: { regex: /^\d{9}$/, expectedFormat: "123456789" },
  GR: { regex: /^EL\d{9}$/, expectedFormat: "EL123456789" },
  HU: { regex: /^HU\d{8}$/, expectedFormat: "HU12345678" },
  IS: { regex: /^\d{6}$/, expectedFormat: "123456" },
  ID: { regex: /^\d{2}\.\d{3}\.\d{3}\.\d-\d{3}\.\d{3}$/, expectedFormat: "12.345.678.9-012.345" },
  IE: { regex: /^IE\d{7}[A-Z]{1,2}$/, expectedFormat: "IE1234567AB" },
  IT: { regex: /^IT\d{11}$/, expectedFormat: "IT12345678912" },
  MY: { regex: /^\d{11}$/, expectedFormat: "12345678912" },
  MX: { regex: /^(MX\d{10}|[A-Z&Ñ]{3}\d{6}[A-Z0-9]{3})$/, expectedFormat: "VME051012XXX or MX1234567890" },
  NZ: { regex: /^\d{11}$/, expectedFormat: "12345678912" },
  NO: { regex: /^NO\d{9}$/, expectedFormat: "NO123456789" },
  SA: { regex: /^\d{10}$/, expectedFormat: "1234567890" },
  SG: { regex: /^\d{11}$/, expectedFormat: "12345678912" },
  ZA: { regex: /^\d{10}$/, expectedFormat: "1234567890" },
  KR: { regex: /^\d{10}$/, expectedFormat: "1234567890" },
  ES: { regex: /^ES\d{8}[A-Z]$/, expectedFormat: "ES12345678Z" },
  CH: { regex: /^CHE\d{9}$/, expectedFormat: "CHE123456789" },
  TH: { regex: /^\d{13}$/, expectedFormat: "1234567890123" },
  AE: { regex: /^\d{15}$/, expectedFormat: "123456789012345" }
};

export const CURRENCY_SYMBOLS = {
  USD: "$",
  CAD: "C$",
  MXN: "MX$",
  EUR: "€",
  DKK: "kr",
  NOK: "kr",
  SEK: "kr",
  NZD: "NZ$",
  AUD: "A$",
  JPY: "¥",
  CNY: "CN¥",
  BRL: "R$",
  SAR: "SR",
};
export const ACCEPTED_LANGUAGES = {
  "en_US": "EN",
  "es_US": "ES",
  "es_XL": "ES",
  "pt_PT": "PT",
  "pt_US": "EN",
  "pt_BR": "PT-BR",
  "pt_XL": "PT-BR",
  "en_XL": "EN",
  "en_CA": "EN",
  "fr_US": "EN",
  "fr_CA": "FR-CA",
  "es_MX": "ES",
  "en_MX": "EN",
  "en_DE": "EN",
  "de_DE": "DE",
  "es_ES": "ES",
  "es_CA": "ES",
  "en_ES": "EN",
  "en_FR": "EN",
  "fr_FR": "FR",
  "en_IE": "EN-GB",
  "en_IT": "EN",
  "it_IT": "IT",
  "en_UK": "EN-GB",
  "en_AU": "EN-GB",
  "en_IN": "EN",
  "en_NZ": "EN-GB",
  "pl_PL": "PL",
  "ja_JP": "JA",
  "zh_CN": "ZH",
  "cs_CZ": "CS",
  "nb_NO": "NB",
  "sv_SE": "SV",
  "ko_KR": "KO",
  "ar_SA": "AR",
  "es_PE": "ES",
  "es_CL": "ES",
  "es_CO": "ES",
  "es_AR": "ES"
}